import { plainSet } from '@ipfabric/utils/fp/plainSet';
import type { MouseEvent, ReactNode } from 'react';
import { Icon } from '../Icon/Icon';
import type { TreePickerItemWithValue } from './helpers/TreePickerItem';
import { getTreePickerItemKeys } from './helpers/getTreePickerItemKeys';

interface Props<TKey> {
  item: TreePickerItemWithValue<TKey>;
  value: Set<TKey>;
  onChange: (items: Set<TKey>) => void;
}

export const TreePickerRemove = <TKey extends string>(
  props: Props<TKey>,
): ReactNode => {
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();

    const keys = getTreePickerItemKeys(props.item);

    props.onChange(plainSet.diff(keys)(props.value));
  };

  return (
    <button
      className='tree-picker__remove-button'
      type='button'
      onClick={handleClick}
    >
      <Icon glyph='fa-circle-xmark' size='sm' />
    </button>
  );
};
